import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';

import useHttpService from '@api/hooks/useHttpService';
import { getCustomerApplicationApiUrl } from '@app/constants/apiUrls';
import { addParamsToPath, routes } from '@app/constants/route.constants';
import useOnboardingParams from '@app/hooks/useOnboardingParams';
import { type CustomerAccountProperties } from '@app/types/createCustomer';

export function useCustomerAccount() {
  const { uid, product } = useOnboardingParams();
  const httpService = useHttpService();
  const navigate = useNavigate();
  const swr = useSWR<CustomerAccountProperties, { response?: { status?: number } }>(
    getCustomerApplicationApiUrl(uid),
    (url: string) => httpService.get<CustomerAccountProperties>(url).then(({ data }) => data)
  );

  const status = swr.error?.response?.status;

  useEffect(() => {
    if (status) {
      const applicationNotFoundUrl = addParamsToPath(routes.ApplicationNotFoundPage, { product, uid });
      navigate(applicationNotFoundUrl);
    }
  }, [status, navigate, product, uid]);

  return swr;
}
